import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ColorPickerEditor from 'common/components/ColorPicker';
import FontPickerEditor from 'common/components/FontPicker';
import { getColors } from 'common/entities/color/selectors';
import { getFonts } from 'common/entities/font/selectors';
import {
    setFormSecondaryButtonTextColorDefault,
    setFormSecondaryButtonTextColorHover,
    setFormSecondaryButtonTextFont,
    setFormSecondaryButtonTextFontSize,
} from 'common/entities/form/styleConfiguration/actions';
import { getFormSecondaryButtonTextStyles } from 'common/entities/form/styleConfiguration/selectors';

import { getFormId } from '../../../../selectors';
import { COLOR_PICKER_DEFAULT, COLOR_PICKER_HOVER } from '../../../../constants/formStyleLabels';
import { SECONDARY_BUTTON_QA } from '../../../../utils/qaIdConstants';

const SecondaryButtonTextPanel = () => {
    const dispatch = useDispatch();
    const formId = useSelector(getFormId);
    const colorList = useSelector(getColors);
    const fontList = useSelector(getFonts);
    const { colors, font, fontSize } = useSelector((state) => getFormSecondaryButtonTextStyles(state, formId));
    const { default: defaultColor, hover: hoverColor } = colors;

    return (
        <React.Fragment>
            <FontPickerEditor
                fontFamilyList={fontList}
                defaultFontFamily={font}
                onChangeFontFamily={(id) => dispatch(setFormSecondaryButtonTextFont(formId, id))}
                defaultFontSize={fontSize}
                onChangeFontSize={(size) => dispatch(setFormSecondaryButtonTextFontSize(formId, size))}
                fontFamilyQa={`${SECONDARY_BUTTON_QA}--fontFamily`}
                fontSizeQa={`${SECONDARY_BUTTON_QA}--fontSize`}
            />
            <ColorPickerEditor
                colorList={colorList}
                firstColorLabel={COLOR_PICKER_DEFAULT}
                firstColor={defaultColor}
                changeFirstColor={(id) => dispatch(setFormSecondaryButtonTextColorDefault(formId, id))}
                secondColorLabel={COLOR_PICKER_HOVER}
                secondColor={hoverColor}
                changeSecondColor={(id) => dispatch(setFormSecondaryButtonTextColorHover(formId, id))}
                qaId={SECONDARY_BUTTON_QA}
            />
        </React.Fragment>
    );
};

export default SecondaryButtonTextPanel;
